/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Overwrite_HeaderInputs */

const en_iconik_publish_overwrite_header = /** @type {(inputs: Iconik_Publish_Overwrite_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overwrite`)
};

const fr_iconik_publish_overwrite_header = /** @type {(inputs: Iconik_Publish_Overwrite_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ecraser`)
};

const de_iconik_publish_overwrite_header = /** @type {(inputs: Iconik_Publish_Overwrite_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überschreiben`)
};

const it_iconik_publish_overwrite_header = /** @type {(inputs: Iconik_Publish_Overwrite_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovrascrivi`)
};

const ru_iconik_publish_overwrite_header = /** @type {(inputs: Iconik_Publish_Overwrite_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перезаписать`)
};

const es_iconik_publish_overwrite_header = /** @type {(inputs: Iconik_Publish_Overwrite_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exagerar`)
};

const zh_cn2_iconik_publish_overwrite_header = /** @type {(inputs: Iconik_Publish_Overwrite_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`覆盖`)
};

const ja_iconik_publish_overwrite_header = /** @type {(inputs: Iconik_Publish_Overwrite_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上書き`)
};

const hi_iconik_publish_overwrite_header = /** @type {(inputs: Iconik_Publish_Overwrite_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओवरराइट`)
};

const pt_pt2_iconik_publish_overwrite_header = /** @type {(inputs: Iconik_Publish_Overwrite_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobrescrever`)
};

/**
* | output |
* | --- |
* | "Overwrite" |
*
* @param {Iconik_Publish_Overwrite_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_overwrite_header = /** @type {((inputs?: Iconik_Publish_Overwrite_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Overwrite_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_overwrite_header(inputs)
	if (locale === "de") return de_iconik_publish_overwrite_header(inputs)
	if (locale === "it") return it_iconik_publish_overwrite_header(inputs)
	if (locale === "ru") return ru_iconik_publish_overwrite_header(inputs)
	if (locale === "es") return es_iconik_publish_overwrite_header(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_overwrite_header(inputs)
	if (locale === "ja") return ja_iconik_publish_overwrite_header(inputs)
	if (locale === "hi") return hi_iconik_publish_overwrite_header(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_overwrite_header(inputs)
	return en_iconik_publish_overwrite_header(inputs)
});